import { hostWidgetCss } from "./widget-css"

const STYLE_ID = "manufacturing-guide-widget-host-styles"

/**
 * Injects compiled `globals.css` into `document.head` once so the UMD build
 * needs no external stylesheet. Shadow tree uses `shadowWidgetCss` from
 * `tailwind-inline.ts` (same source, deduped in the bundle).
 */
export function ensureManufacturingGuideHostStyles(): void {
    if (typeof document === "undefined") return
    if (document.getElementById(STYLE_ID)) return
    const el = document.createElement("style")
    el.id = STYLE_ID
    el.textContent = hostWidgetCss
    document.head.appendChild(el)
}

ensureManufacturingGuideHostStyles()
